export default (name: string, value: string, days = 365): void => {
  if (typeof document !== 'undefined') {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    // Some Local storage have spaces, use encodeURIComponent for compatibility
    document.cookie = `${name}=${encodeURIComponent(value)};path=/;expires=${d.toUTCString()}`;
  }
};

